import React from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../services/auth";
import styled from "styled-components";
import { Box, Grid, Paper } from "@mui/material";
import { DescriptionTwoTone } from "@mui/icons-material";
const InvoicesPage = () => {
  const navigate = useNavigate();
  const { role } = useAuth();
  let nfcTypes = [
    {
      name: "Odoo Invoices",
      icon: (
        <DescriptionTwoTone
          color="action"
          fontSize="large"
        ></DescriptionTwoTone>
      ),
      route: "OdooInvoices",
    },
    {
      name: "Shift Odoo Journal Entry",
      icon: (
        <DescriptionTwoTone
          color="action"
          fontSize="large"
        ></DescriptionTwoTone>
      ),
      route: "ShiftOdooJournalEntry",
    },
    ...(role === "Admin"
      ? [
          {
            name: "Odoo Accounts",
            icon: (
              <DescriptionTwoTone
                color="action"
                fontSize="large"
              ></DescriptionTwoTone>
            ),
            route: "OdooAccounts",
          },
        ]
      : []),
    {
      name: "Odoo Invoices Report",
      icon: (
        <DescriptionTwoTone
          color="action"
          fontSize="large"
        ></DescriptionTwoTone>
      ),
      route: "OdooInvoicesReport",
    },
  ];

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: "#F7F9FB",
    padding: 5,
    textAlign: "center",
    color: "#1C1C1C",
    width: "500px",
  }));

  return (
    <>
      <Box sx={{ flexGrow: 1, mt: 2 }}>
        <Grid
          container
          spacing={{ xs: 2, md: 10 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {nfcTypes.map((report, index) => (
            <Grid item xs={2} sm={6} md={6} key={index}>
              <Item>
                <Box sx={{ flexGrow: 1, display: "flex" }}>
                  <Box
                    sx={{
                      flex: "1",
                      mt: 1,
                      mr: 2,
                      fontSize: "24px",
                      textAlign: "right",
                    }}
                  >
                    {report.icon}
                  </Box>
                  <Box
                    sx={{ flex: "3", textAlign: "left", cursor: "pointer" }}
                    onClick={() => navigate(report.route)}
                  >
                    <Box sx={{ fontWeight: "bold" }}>{report.name}</Box>
                    <Box>Details ...</Box>
                  </Box>
                </Box>
              </Item>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default InvoicesPage;
